export enum MenuSettings {
  StoreSetting = 'store-setting',
  OrganisationSetting = 'organisation-setting',
}
